module.exports = "/build/web/svg/fanzone.bdc7dd2e6c010a232d006c08151a2453.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/fanzone.svg
// module id = 166
// module chunks = 24